module.exports = "/images/browserconfig.xml";


//////////////////
// WEBPACK FOOTER
// ./resources/img/favicon/browserconfig.xml
// module id = 28
// module chunks = 0